import api from '../../../../helpers/api';

export const getMyArtisanPrivateInquiry = body =>
  api.post('private-artisan-inquiry/get-single-artisan-private-inquiry/', {
    ...body
  });

export const getMyArtisanPrivateInquiries = body =>
  api.post(
    body.url
      ? body.url
      : 'private-artisan-inquiry/search-artisan-private-ainquiries/',
    body
  );

export const addProposalByArtisan = body =>
  api.post(`private-artisan-inquiry/add-artisan-private-proposal`, { ...body });

export const addStagingProposalByArtisan = body =>
  api.post(`/private-artisan-staging-proposals/create`, { ...body });

export const editProposalByArtisan = body =>
  api.post(`private-artisan-inquiry/edit-artisan-private-proposal`, {
    ...body
  });

export const editStagingProposalByArtisan = body =>
  api.post(`private-artisan-staging-proposals/update`, { ...body });
